import { animation } from "./_animation";

animation();

